<template>
  <VView class="rules" back-button-to="/menu" :header="$t('rules.header')">
    <VText><small><span>1.</span> Sprawdź się w roli operatora dźwigu od dickie toys i <span>ciesz się ukończoną misją.</span> Czekają na ciebie trzy poziomy różniące się stopniem trudności!</small></VText>
    <VText><small><span>2.</span> odpowiedz w ciekawy sposób na <span>pytanie konkursowe.</span> następnie wraz z opiekunem wypełnijcie <span>formularz osobowy,</span> abyśmy mogli się z wami skontaktować w przypadku wygranej.</small></VText>
    <VText><small><span>3.</span> jury spośród wszystkich zgłoszeń wybierze laureatów, którzy otrzymają nagrody!</small></VText>

    <VText center>Konkurs trwa od 01.03 do 28.03.2022.<br />Szczegóły znajdziesz w <a :href="$t('app.regulations')" target="_blank">regulaminie.</a></VText>

    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton to="/contest" special>Laureaci</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Rules',
  components: {
    VView,
    VText,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss" scoped>
.rules {}
</style>
